import { GetterTree } from 'vuex'

import { RootState, MultiUserState } from '@/types/store'

export const getters: GetterTree<MultiUserState, RootState> = {
  multiUser(state): MultiUserState['multiUser'] {
    return state.multiUser
  },
  multiUsers(state): MultiUserState['multiUsers'] {
    return state.multiUsers
  },
  total(state): MultiUserState['total'] {
    return state.total
  },
  isMultiUsersLoading(state): MultiUserState['isMultiUsersLoading'] {
    return state.isMultiUsersLoading
  },
  searchCondition(state): MultiUserState['searchCondition'] {
    return state.searchCondition
  },
}
